import { ErrorMessage, FieldArray, Form, Formik } from 'formik';
import { ModalStatusType } from '../../../types/common';
import ModalComponent from '../../../components/modal/modal';
import ModalBodyComponent from '../../../components/modal/modalBodyComponent';
import InputText from '../../../components/input-text/inputText';
import ModalFooterComponent from '../../../components/modal/modalFooterComponent';
import { Label } from '../../../components/input-text/input.styled';
import ImageViewer from '../../../components/input-file/inputFileWithView';
import React, { useEffect, useState } from 'react';
import CustomTextArea from '../../../components/text-area/textArea';
import InitialValuesForm from '../../../constants/initialValues';
import ImageViewerSingle from '../../../components/input-file/inputFileWithViewSingle';
import { isEmpty, values } from 'lodash';
import {
  useAdvanceBoolean,
  useGetCheckPlanGrantDocumentName,
  useGetPlanGrantDocumentDetailById,
  usePostPlanGrantDocumentDetailByPlanGrantDocumentId,
  usePutPlanGrantDocumentDetail,
  useWealthlaneAwardApi,
} from '../../../hooks';
import { SwitchContainer } from './planManagement.styled';
import Heading from '../../../components/typography';
import RichTextEditor from '../../../components/rich-text-editor';
import { PLAN_DOCUMENT_VALIDATION } from '../../../utils/validations/validations';
import moment from 'moment';
import Button from '../../../components/button';
import {
  useDynamicTable,
  DynamicTable,
  withDynamicTableContext,
  useTableSchemaLoader,
} from '@wealthlane/table-builder';
import { PlanGrantDocumentHeader } from '../../../constants/table-headers/planGrantDocumentHeader';
import AlertPopup from '../../../components/alert-popup';
import { PlanService } from '@wealthlane/api-services/wealthlane-award-service';
import { toast } from 'react-toastify';
import ToastComponent from '../../../components/toast';
import { useQueryClient } from 'react-query';
import { EditedRow } from '../../../packages/table-builder/components/Table';
import { axiosInstance } from '../../../services/apiInterceptor';

interface GrantDocumentModelType {
  isModalOpen: boolean;
  closeModal: () => void;
  modalStatus: ModalStatusType;
  //   setModalStatus: (value: ModalStatusType) => void;
  initialData: {
    data: any;
    id: string;
  };

  rowData?: any;
  id?: string;
  planId?: string;
  modelName?: string;
  documentDto?: any;
  setDocumentDto: any;
  documentType?: string | number | null;
  setDocumentType?: any;
  planDocumentStatus?: string;
  setPlanDocumentStatus?: any;
  domId?: string;
}

const GrantDocumentModel = ({
  isModalOpen,
  closeModal,
  modalStatus,
  initialData,
  //   setModalStatus,
  rowData,
  id,
  planId,
  modelName,
  documentDto,
  setDocumentDto,
  documentType,
  setDocumentType,
  planDocumentStatus,
  setPlanDocumentStatus,
  domId
}: GrantDocumentModelType): JSX.Element => {
  const [removedId, setRemovedId] = useState<string[]>([]);
  const { errors, setErrors } = useDynamicTable();
  const [loading, setLoading] = useState<boolean>(false);
  const { handleRequest } = useWealthlaneAwardApi();
  const [checkNameError, setCheckNameError] = useState();
  const [toggle, setToggle] = useState<boolean>(false);
  const [planGrantDocumentInitialData, setPlanGrantDocumentInitialData] = useState<any>();
  const [resetFiles, setResetFiles] = useState<boolean>(false);
  const {
    value: isConfirmOpen,
    setFalse: closeConfirmModal,
    setTrue: openConfirmModal,
    customValue: confirmCustomValue,
    setCustomValue: setConfirmCustomValue,
  } = useAdvanceBoolean<string>(false);
  const {
    value: isSaveOpen,
    setFalse: closeSaveModal,
    setTrue: openSaveModal,
    customValue,
    setCustomValue,
  } = useAdvanceBoolean<string>(false);
  const [modalLoading, setModalLoading] = useState(false);
  const queryClient = useQueryClient();

  const { mutate: checkName } = useGetCheckPlanGrantDocumentName(
    handleRequest,
    documentType,
    setCheckNameError
  );
  const { mutate: planGrantDocumentDetailMutate, isLoading: planGrantDocumentDetailLoading } =
    usePostPlanGrantDocumentDetailByPlanGrantDocumentId(
      handleRequest,
      planGrantDocumentInitialData?.id,
      setResetFiles
    );
  const {
    mutate: editPlanGrantDocumentDetailMutate,
    isLoading: editPlanGrantDocumentDetailLoading,
  } = usePutPlanGrantDocumentDetail(handleRequest, closeSaveModal, (message, newErrors) => {
    setErrors([...errors, ...newErrors]);
  });

  const {
    data: planGrantDocumentDetailsById,
    isLoading: planGrantDocumentByIdLoading,
    status: planGrantDocumentByIdStatus,
  } = useGetPlanGrantDocumentDetailById(handleRequest, id);

  useEffect(() => {
    if (planGrantDocumentDetailsById && planDocumentStatus === 'Edit') {
      setPlanGrantDocumentInitialData({
        ...planGrantDocumentDetailsById,
        grantDocumentName: planGrantDocumentDetailsById?.documentName,
        document: [],
        planGrantDocumentDetails: planGrantDocumentDetailsById?.planGrantDocumentDetails
          ?.slice() // create a shallow copy
          ?.sort((a: any, b: any) => {
            // Sort descending by effectiveDate (latest first)
            const dateA = moment(a.effectiveDate, 'MM-DD-YYYY').toDate();
            const dateB = moment(b.effectiveDate, 'MM-DD-YYYY').toDate();
            return dateA.getTime() - dateB.getTime();
          })
          .map((item: any) => ({
            ...item,
            planId: planId,
          })),
      });
    }
  }, [planGrantDocumentDetailsById, planDocumentStatus]);

  const handleImageOpen = (name: string): void => {
    setLoading(true);

    setLoading(false);
  };

  function generateId() {
    return `${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
  }

  const handleSubmit = (
    values: any,
    documentType?: string | number | null,
    documentDto?: any
  ): void => {
    const ext =
      documentType !== 4 ? '.' + values?.document?.[0]?.[0]?.name?.split('.')?.reverse()[0] : '';
    setLoading(true);
    setDocumentDto([
      ...documentDto,
      {
        ...values,
        grantDocumentName: values?.grantDocumentName,
        description: values?.description,
        document: values?.document?.[0]?.base64String,
        grantDocumentType: toggle ? 4 : documentType,
        fileExtension: ext,
        uniqueDocId: values?.grantDocumentName + ext + documentType + generateId(),
        planGrantDocumentDetails: [
          {
            effectiveDate: moment().format('MM-DD-YYYY'),
            isActive: true,
            fileContentName: values?.document?.[0]?.[0]?.name,
            document: values?.document?.[0]?.base64String,
            fileExtension: ext,
          },
        ],
      },
    ]);

    closeModal();
    setLoading(false);
  };

  const { schemaData, isTableSchemaLoading } = useTableSchemaLoader({
    identifier: 'PLAN_GRANT_DOCUMENT_TABLE',
    baseUrl: process.env.REACT_APP_WEALTHLANE_API_ENDPOINT,
  });

  const schema = React.useMemo(
    () => ({
      columns: PlanGrantDocumentHeader({
        actions: schemaData?.columns,
        setConfirmCustomValue,
        openConfirmModal,
      }),
      options: schemaData?.options as any,
      apiInjection: schemaData?.apiInjection as any,
    }),
    [schemaData]
  );

  const handleSave = async (editedData: EditedRow[]) => {
    openSaveModal();
    setCustomValue(editedData as any);
  };
  const handelAddDocument = async (values) => {
    const ext =
      documentType !== 4 ? '.' + values?.document?.[0]?.[0]?.name?.split('.')?.reverse()[0] : '';

    const payload = [
      {
        effectiveDate: moment().format('MM-DD-YYYY'),
        isActive: true,
        fileContentName: values?.document?.[0]?.[0]?.name,
        document: values?.document?.[0].base64String,
        fileExtension: ext,
      },
    ];
    planGrantDocumentDetailMutate(payload as any);
  };

  const mapToPayloadFormat = (customValue: Record<string, any>[]) => {
    return [
      {
        effectiveDate: customValue?.[0]?.changes?.effectiveDate,
        isActive: customValue?.[0]?.changes?.isActive,
        fileContentName: customValue?.[0]?.changes?.fileContentName,
        document: customValue?.[0]?.changes?.document,
        fileExtension: customValue?.[0]?.changes?.fileExtension,
        id: customValue?.[0]?.changes?.id,
        isDocumentContentChanged: true,
      },
    ];
  };

  const editSECFee = async () => {
    try {
      const payload = mapToPayloadFormat(customValue);
      await editPlanGrantDocumentDetailMutate(payload as any);
    } catch (error) {
    } finally {
      setCustomValue(null);
      closeSaveModal();
    }
  };

  const onPrimaryClick = (values: Record<string, any>): void => {
    deleteBroadcastMessageById(confirmCustomValue);
  };

  const deleteBroadcastMessageById = (id: string): void => {
    setModalLoading(true);
    handleRequest(PlanService.deleteApiAwardApiAppPlanPlanGrantDocumentDetailById(id))
      .then((data: any) => {
        if (data?.success) {
          toast.success(
            <ToastComponent label={'Success'} message={'Plan Grant Document deleted.'} />
          );
          void queryClient.invalidateQueries('getPlanGrantDocumentDetailById');
          setModalLoading(false);
          closeConfirmModal();
        }
      })
      .catch(() => {
        setModalLoading(false);
        closeConfirmModal();
      })
      .finally(() => {
        setModalLoading(false);
        closeConfirmModal();
      });
  };

  return (
    <Formik
      enableReinitialize
      initialValues={
        planGrantDocumentInitialData
          ? planGrantDocumentInitialData
          : InitialValuesForm?.grantDocumentModel
      }
      validationSchema={PLAN_DOCUMENT_VALIDATION}
      onSubmit={(values) => {
        handleSubmit(values, documentType, documentDto);
      }}>
      {({
        touched,
        handleChange,
        errors,
        setFieldValue,
        setFieldTouched,
        values,
        setTouched,
        setFieldError,
      }: any) => {
        useEffect(() => {
          if (documentType === 4) {
            setFieldValue('text', true);
          }
        }, []);

        return (
          <>
            <ModalComponent
              show={isModalOpen}
              closeModal={closeModal}
              loading={false}
              size='lg'
              //   valueEdited={_.isEqual(
              //     values,
              //     modalStatus !== 'Add' ? initialValue : initialData?.data
              //   )}
              customAlertMessage={'Your changes will not be saved. Are you sure you want to close?'}
              title={`${planDocumentStatus} ${modelName}`}
              id={domId}
              children={
                <Form id="grantDocumentForm">
                  <ModalBodyComponent id="grantDocumentModalBody">
                    <div id="grantDocumentContent">
                      <InputText
                        type='text'
                        label='Name'
                        name='grantDocumentName'
                        onChange={(e: any) => {
                          // checkName && checkName(e.target.value);
                          handleChange(e);
                        }}
                        errors={errors}
                        touched={touched}
                        //   inputType={modalStatus}
                        disabled={planDocumentStatus === 'Edit'}
                        required
                        id="grantDocumentNameInput"
                      />
                      <CustomTextArea
                        label='Description'
                        name='description'
                        onChange={handleChange}
                        errors={errors}
                        inputType={modalStatus}
                        disabled={modalStatus === 'View'}
                        touched={touched}
                        rows='5'
                        id="grantDocumentDescriptionInput"
                      />

                      {documentType === 4 ? (
                        <div className='grid grid-cols-12' id="termsAndConditionsSection">
                          {modalStatus !== 'View' ? (
                            <div className='col-span-12'>
                              <>
                                <RichTextEditor
                                  name='grantTermsAndConditionText'
                                  label='Terms and Condition Text'
                                  setFieldValue={setFieldValue}
                                  value={
                                    (values?.grantTermsAndConditionText as boolean)
                                      ? values?.grantTermsAndConditionText
                                      : ''
                                  }
                                  error={errors?.grantTermsAndConditionText}
                                  touched={touched?.grantTermsAndConditionText}
                                  id="grantTermsAndConditionTextEditor"
                                />
                              </>
                              <ErrorMessage
                                name='grantTermsAndConditionText'
                                component='div'
                                className='error-message'
                              />
                            </div>
                          ) : (
                            <div className='col-span-12'>
                              <Label>Description</Label>

                              <div
                                dangerouslySetInnerHTML={{
                                  __html: values?.grantTermsAndConditionText,
                                }}
                                className={`border p-2 text-2xl rounded-lg bg-[#F3F3F3] descriptionOutput`}
                                id="grantTermsAndConditionTextDisplay"
                              />
                            </div>
                          )}
                        </div>
                      ) : (
                        <>
                          <Label htmlFor={'document'} className={'pb-1'}>
                            {modalStatus === 'View' ? '' : 'Upload'} Documents{' '}
                          </Label>
                          <div id="grantDocumentFileUpload">
                            <ImageViewerSingle
                              setFieldValue={setFieldValue}
                              setFieldTouched={setFieldTouched}
                              modalStatus={modalStatus}
                              values={values}
                              errors={errors}
                              touched={touched}
                              errorValue={errors?.document}
                              touchedValue={touched?.document}
                              name='document'
                              listingName='documentNameList'
                              accept='.pdf, .jpg, .jpeg, .png, .docx, .doc'
                              loading={loading}
                              removedId={removedId}
                              handleImageOpen={handleImageOpen}
                              setRemovedId={setRemovedId}
                              uploadLimit={1}
                              isSingleFile={true}
                              setFieldError={setFieldError}
                              isBase64={true}
                              resetFiles={resetFiles}
                            />
                          </div>
                        </>
                      )}

                      {planDocumentStatus === 'Edit' && (
                        <>
                          <div className='flex justify-end mt-4 mb-4' id="addDocumentSection">
                            <Button
                              as='Create'
                              type='button'
                              variant={'primary-outline'}
                              title={'Add Document'}
                              icon={'add_circle_outline'}
                              loading={planGrantDocumentDetailLoading}
                              onClick={async () => {
                                await setFieldTouched('document', true, true);
                                if (!errors?.document) {
                                  handelAddDocument(values);
                                }
                              }}
                              id="addDocumentButton"
                            />
                          </div>

                          <DynamicTable
                            schema={schema}
                            data={planGrantDocumentInitialData?.planGrantDocumentDetails || []}
                            loading={'success'}
                            totalCounts={
                              planGrantDocumentInitialData?.planGrantDocumentDetails?.length ?? 10
                            }
                            onSave={handleSave}
                            isSaveLoading={false}
                            components={{}}
                            id="grantDocumentTable"
                          />
                          {isSaveOpen && (
                            <AlertPopup
                              isShow={isSaveOpen}
                              closeModal={closeSaveModal}
                              customTitle={
                                <div className='text-center w-full'>
                                  Are you sure you want to Save?
                                </div>
                              }
                              handleSubmit={editSECFee}
                              loading={false}
                              id="saveGrantDocumentAlert"
                            />
                          )}
                          {isConfirmOpen && (
                            <AlertPopup
                              isShow={isConfirmOpen}
                              closeModal={closeConfirmModal}
                              customTitle={
                                <div className='text-center w-full'>
                                  Are you sure you want to Delete?
                                </div>
                              }
                              handleSubmit={onPrimaryClick}
                              loading={modalLoading}
                              id="deleteGrantDocumentAlert"
                            />
                          )}
                        </>
                      )}
                    </div>
                  </ModalBodyComponent>
                  <ModalFooterComponent
                    modalStatus={planDocumentStatus === 'Edit' ? 'View' : 'Add'}
                    checkError={false}
                    loading={false}
                    isEditShow={planDocumentStatus === 'Edit' ? false : true}
                    // isButton={true}
                    buttonTitle='Add'
                    // isTmc={modalStatus === 'View' && id ? true : false}
                    onCloseModal={() => {
                      closeModal();
                    }}
                    valueChanged={false}
                    // onEditModal={() => {
                    //   setModalStatus('Edit');
                    // }}
                    customAlertMessage={
                      'Your changes will not be saved. Are you sure you want to close?'
                    }
                    id="grantDocumentModalFooter"
                  />
                </Form>
              }
            />
          </>
        );
      }}
    </Formik>
  );
};

export default withDynamicTableContext(GrantDocumentModel, false, axiosInstance);
